
import React from "react";
import { Button } from "../ui/button";

const AddressUpdateConfirmationModal = ({ formData, updatedData, onContinue, onDiscard }) => {
    // Keys related to address
    const addressKeys = [
      "addressLine1",
      "addressLine2",
      "addressLine3",
      "city",
      "state",
      "postcode",
      "postCode",
      "country",
      "countryOfIncorporation",
      "CountryName",
      "uboCharityAddress",
      "uboRegisteredOfficeAddress",
      "uboBusinessAddress",
      "uboRegisteredAddress",
      "uboLegalPersonRegisteredOfficeAddress",
      "uboAddress",
      "Address",
      "uboaddressLine1",
      "uboaddressLine2",
      "uboaddressLine3",
      "ubocountry",
      "ubocity",
      "ubopostalCode",

    ];
  
  // Filter and create displayFormData and displayUpdatedData with only non-empty address-related fields
  // Detect the "No Response" sentinel
  const isNoResponse = updatedData === "No Response";

  const displayFormData = {};
  const displayUpdatedData = {};

  addressKeys.forEach((key) => {
    const formValue = formData?.[key];
    const updatedValue = updatedData?.[key];

    if (formValue) {
      displayFormData[key] = formValue;
    }
    if (updatedValue) {
      displayUpdatedData[key] = updatedValue;
    }
  });

  const displayKeys = Array.from(new Set([
    ...Object.keys(displayFormData),
    ...Object.keys(displayUpdatedData)
  ]));
  // console.log("formData in modal:",formData)
  // console.log("updatedData in modal:",updatedData)
  const displayNameMap = {
    uboCharityAddress: "Address",
    uboRegisteredOfficeAddress: "Address",
    uboBusinessAddress: "Address",
    uboRegisteredAddress: "Address",
    uboLegalPersonRegisteredOfficeAddress: "Address",
    uboAddress: "Address",
    countryOfIncorporation: "Country",
    uboaddressLine1: "Address Line 1",
    uboaddressLine2: "Address Line 2",
    uboaddressLine3: "Address Line 3",
    ubocountry: "Country",
    ubocity: "City",
    ubopostalCode: "Postal Code",

  };
  
  const getDisplayName = (key) => displayNameMap[key] || key;

  return (
    <div className="w-full max-w-5xl bg-white p-6 rounded-md shadow-lg">
    
      
      {/* <div className="flex gap-6 max-h-[60vh] overflow-y-auto" style={{display: "flex", gap:"10px", alignItems:"center"}}>
     
        <div className="w-1/2 border-r pr-4" style={{borderRight: "1px solid #000",padding:"15px"}}>
          <h3 className="font-semibold text-lg mb-4" style={{marginBottom: "20px",color:"#07b1b0", textDecoration:"underline"}}>Current Address</h3>
          {displayKeys.map((key) => (
            <div key={key} style={{marginBottom:"15px",textAlign:"left"}}>
              <span style={{fontWeight:"bold", marginRight:"5px"}}>{key}:</span> {displayFormData[key] || "—"}
            </div>
          ))}
          <div className="mt-6">
            <button onClick={onDiscard} style={{marginBottom: "10px",color:"#fff", backgroundColor:"#07b1b0", padding:"10px",borderRadius:"8px", border:"none", cursor:"pointer",float:"left"}}>Keep</button>
          </div>
        </div>

        
        <div className="w-1/2 pl-4" style={{padding:"15px"}}>
          <h3 className="font-semibold text-lg mb-4" style={{marginBottom: "20px",color:"#07b1b0", textDecoration:"underline"}}>Validated Address</h3>
          {displayKeys.map((key) => (
            <div key={key} style={{marginBottom:"15px",textAlign:"left"}}>
              <span style={{fontWeight:"bold", marginRight:"5px"}}>{key}:</span> {displayUpdatedData[key] || "—"}
            </div>
          ))}
          <div className="mt-6">
            <button onClick={onContinue} style={{marginBottom: "10px",color:"#fff", backgroundColor:"#07b1b0", padding:"10px",borderRadius:"8px", border:"none", cursor:"pointer", float:"left"}}>Replace</button>
          </div>
        </div>
      </div> */}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <thead>
      <tr>
        <th style={{
          width: "50%",
          padding: "15px",
          border: "1px solid #ccc",
          color: "#07b1b0",
          textDecoration: "underline",
          textAlign: "left",
          backgroundColor: "#f9f9f9"
        }}>
          Inputted Address
        </th>
        <th style={{
          width: "50%",
          padding: "15px",
          border: "1px solid #ccc",
          color: "#07b1b0",
          textDecoration: "underline",
          textAlign: "left",
          backgroundColor: "#f9f9f9"
        }}>
          Royal Mail Address
        </th>
      </tr>
    </thead>
    <tbody>
      {displayKeys.map((key) => (
        <tr key={key}>
          <td style={{ padding: "10px 15px", border: "1px solid #ccc", textAlign: "left", verticalAlign: "top" }}>
            <strong style={{ textTransform: "capitalize" }}>{getDisplayName(key) }:</strong> {displayFormData[key] || "—"}
          </td>
          <td style={{ padding: "10px 15px", border: "1px solid #ccc", textAlign: "left", verticalAlign: "top" }}>
                {isNoResponse
                  ? <em>No Response</em>
                  : <>
                      <strong style={{ textTransform: "capitalize" }}>{getDisplayName(key) }:</strong> {displayUpdatedData[key] || "—"}
                    </>
                }
          </td>
        </tr>
      ))}
      <tr>
        <td style={{ padding: "15px", border: "1px solid #ccc", textAlign: "left" }}>
          <button
            onClick={onDiscard}
            style={{
              marginTop: "10px",
              color: "#fff",
              backgroundColor: "#07b1b0",
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer"
            }}
          >
            Keep
          </button>
        </td>
        <td style={{ padding: "15px", border: "1px solid #ccc", textAlign: "left" }}>
          <button
            onClick={onContinue}
            style={{
              marginTop: "10px",
              color: "#fff",
              backgroundColor: "#07b1b0",
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer"
            }}
          >
            Replace
          </button>
        </td>
      </tr>
    </tbody>
  </table>

    </div>
  );
};

export default AddressUpdateConfirmationModal;

